import React from 'react';
import {
  Body,
  Link,
  SecondaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from 'shared/utils/translation';
import { SelectionsHelper } from 'talent_matching/hooks/use_selections_helper';
import { GridApi } from '@mui/x-data-grid';
import { useIndexingStatus } from 'talent_matching/contexts/indexing_status_context';

const t = withLocalePrefix('talent_matching.header_row');

type Props = {
  selectionsHelper: SelectionsHelper;
  apiRef: React.MutableRefObject<GridApi>;
};

const SelectionHeader = ({ selectionsHelper, apiRef }: Props) => {
  const { indexingInProgress } = useIndexingStatus();

  if (selectionsHelper.noneSelected) {
    return (
      <Stack direction="row" spacing={2} alignItems="center">
        <Body medium>
          {t('candidates', { count: selectionsHelper.totalCount })}
        </Body>
        {indexingInProgress && (
          <SecondaryBody metadata>{t('indexing.in_progress')}</SecondaryBody>
        )}
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Body medium>
        {t('selected', { count: selectionsHelper.totalSelected })}
      </Body>
      <Link
        onClick={() => {
          apiRef.current.setRowSelectionModel([]);
        }}
      >
        {t('clear')}
      </Link>
    </Stack>
  );
};

export default SelectionHeader;
